import { TagCommand, Command, CommandTypes, Options } from './@types/commands';

import { addOptions } from './environment';
import { handleTag } from './tag';

/**
 * Commands aren't clean from a historical point of view, until we
 * change the back end to reflect that for what gets dropped on a /tag call.
 * We can only clean this up 100% once we migrate to this new re-write, so for now
 * lets translate things into an action-like payload for sanities sake for the time
 * being and once we're live with this, can create these payloads on the backend
 */
export const sanitiseCommand = (command: Command) => {
  if (!Array.isArray(command) && typeof command === 'object') {
    return {
      type: CommandTypes.config,
      payload: command,
    };
  }

  if (command[0] === CommandTypes.tag) {
    const [type, target, tagId, pageOptions, config] = command;
    return {
      type: CommandTypes.tag,
      payload: {
        target,
        tagId,
        page: { ...config.options, ...pageOptions },
        config: config.extras,
      },
    };
  }

  return {
    type: CommandTypes.unknown,
    payload: {},
  };
};

/**
 * Based on the command `type`, send the command to the right
 * place for processing
 */
export const processCommands = (
  command: ReturnType<typeof sanitiseCommand>,
) => {
  switch (command.type) {
    case CommandTypes.tag:
      handleTag(command.payload as TagCommand);
      break;
    case CommandTypes.config:
      addOptions(command.payload as Options);
      break;
    case CommandTypes.unknown:
      // do something
      break;
    default:
    // shouldn't ever get here
  }
};
